
export default function formCadastroUpdatePublicDTO({
        nome, 
        nascimento, 
        email, 
        login, 
        celular,
        rua, 
        numero, 
        bairro, 
        complemento, 
        cep, 
        cidade,
        uf
    }){ 
        return{
        nome, 
        nascimento, 
        email, 
        login, 
        celular,
        rua, 
        numero, 
        bairro, 
        complemento, 
        cep, 
        cidade, 
        uf
    }
}